<template>
	<table>
		<caption>Consignment Summary</caption>
		<thead>
			<tr>
				<th>Connote</th>
				<th>Consigned</th>
				<th>Reference</th>
				<th>Sender</th>
				<th>Receiver</th>
				<th>ETA</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>{{ consignmentNote }}</td>
				<td>{{ consigned }}</td>
				<td>{{ reference }}</td>
				<td>{{ sender }}</td>
				<td>{{ receiver }}</td>
				<td>{{ eta }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>

	import moment from 'moment'

	export default {
		props: {
			consignmentNote: String,
			consigned: String,
			reference: String,
			sender: String,
			receiver: String,
			eta: String
		}	}

</script>